module.exports = __webpack_public_path__ + "static/media/moon_logo.2ba4bab1.svg";